<h3>{{ versionDoc.publicationDate }} - {{ versionDoc.creator }}</h3>
<p>{{ versionDoc.teaserSummary }}</p>
<button [routerLink]="['../'+versionDoc.uniqueNumber]" [queryParams]="{ version: 'this'}" class="Button">{{getOtherVersionDisplayMessage()}}</button>
